/* eslint-disable react/display-name */
import React, { useEffect } from 'react';
import { cssTransition, toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
import { Icon } from '../../../concepts/resources/Icon';
import { Sebastian } from '../../canvas/ui/Sebastian';
import { useResolve } from '../../Container';
import { ToastHub, ToastInstance } from './ToastHub';
import { ToastTheme } from './ToastTheme';

const ToastZoom = cssTransition({
    enter: 'toastIn',
    exit: 'toastOut',
    duration: 500,
});

const ToastMount = styled.div`
    display: flex;
    align-items: center;

    ${Sebastian} {
        flex: 0 0 auto;
        width: 4rem;
        height: 4rem;
        margin: -0.5rem 0.3rem 0.7rem -0.2rem;
    }
    .toast-icon {
        flex: 0 0 auto;
        width: 2.625rem;
        height: 2.625rem;
        margin: 1rem 1rem 1rem 0.625rem;
    }
`;

const calls = {
    'info': 'info',
    'positive': 'success',
    'warning': 'warning',
    'negative': 'error',
};

const createToast = ({ icon, body }: ToastInstance) => {
    return () => <>
        <ToastMount>
            {icon.startsWith('deqo://') ? <Icon className="toast-icon" src={icon} /> : <Sebastian stance={icon as any} />}
            <span>{body}</span>
        </ToastMount>
    </>;
};

const realizeToast = (ti: ToastInstance) => {
    const Realized = createToast(ti);
    toast[calls[ti.type]](Realized);
};

const ToastBridge = () => {
    const hub = useResolve(ToastHub);
    useEffect(() => hub.on('invoke', realizeToast));
    return null;
};

export class ToastLayer extends React.Component {

    public render() {
        return <ToastTheme>
            <ToastBridge />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                newestOnTop={false}
                draggable={false}
                transition={ToastZoom}
                closeOnClick
                hideProgressBar
                pauseOnHover
            />
        </ToastTheme>;
    }
}
